import { memo } from "react";
import { useTheme } from "../../hooks/useTheme";
import FullEventTimeCard from "./FullEventTimeCard";
import { Event } from "@markit/common.types";
import { Icon } from "@iconify/react";
import { Colors } from "../../utils/colors";
import { truncateString } from "@markit/common.utils";
import CustomLinkify from "../Links/CustomLinkify";

type FullEventTimeLocationProps = {
  event: Event;
  isRCABool: boolean;
  numOfApprovedTickets: number;
};

const FullEventTimeLocation = memo(function FullEventTimeLocationFn(
  props: FullEventTimeLocationProps
) {
  const { event, numOfApprovedTickets } = props;

  const { theme } = useTheme();

  return (
    <>
      <div className="AlignedRow">
        <FullEventTimeCard event={event} />
      </div>
      <div className="AlignedRow" style={{ gap: 14 }}>
        <div
          className="InfoContainerIcon"
          style={{
            ...theme.NewPrimaryBG,
            border: `0.5px solid ${theme.EditableTextFieldBorder.borderColor}`,
          }}
        >
          {event.isVirtual ? (
            <Icon icon="ion:videocam" height={24} style={theme.PrimaryText} />
          ) : event.privateLocation && numOfApprovedTickets === 0 ? (
            <Icon
              icon="ion:lock-closed"
              height={31}
              style={theme.PrimaryText}
            />
          ) : (
            <Icon
              icon="mdi:map-marker"
              height={31}
              style={{ color: Colors.BLUE5 }}
            />
          )}
        </div>
        <div
          className="ColumnNormal"
          style={{ gap: 4 }}
          onClick={
            event.isVirtual || numOfApprovedTickets === 0
              ? () => {}
              : () => {
                  window.open(
                    "https://www.google.com/maps/search/?api=1&query=Google&query_place_id=" +
                      event.googlePlaceId
                  );
                }
          }
        >
          <span
            className="bodyMedium"
            style={{ ...theme.PrimaryText, cursor: "pointer" }}
          >
            {event.isVirtual
              ? "Virtual"
              : event.privateLocation && numOfApprovedTickets === 0
              ? "Hidden Location"
              : truncateString(event.googleDescription, 40, "...")}
          </span>
          <div className="AlignedRow" style={{ gap: "5px" }}>
            <span
              className="bodySubtext"
              style={{ ...theme.LabelText, cursor: "pointer" }}
            >
              {event.isVirtual
                ? "This is a virtual event"
                : event.privateLocation && numOfApprovedTickets === 0
                ? "Location available if accepted"
                : truncateString(event.formattedAddress, 40, "...")}
            </span>
            {!event.isVirtual &&
            event.privateLocation &&
            numOfApprovedTickets > 0 ? (
              <Icon
                icon="ion:open-outline"
                height={16}
                style={{ ...theme.LabelText }}
              />
            ) : null}
          </div>
        </div>
      </div>
      {event.locationDetails !== "" && numOfApprovedTickets > 0 ? (
        <>
          <hr style={theme.DividerColor} />
          <div className="ColumnNormal" style={{ marginBottom: 10 }}>
            <CustomLinkify>
              <div
                className="LocationDetails"
                style={{
                  ...theme.PrimaryText,
                  whiteSpace: "pre-wrap",
                  overflowWrap: "break-word",
                }}
              >
                {event.isVirtual ? "Webinar Link: " : ""}
                {event.locationDetails}
              </div>
            </CustomLinkify>
          </div>
        </>
      ) : null}
    </>
  );
});

export default FullEventTimeLocation;
